import React from 'react'
import CLog from '../client/pages/c-log/home'
import ImageClogs from '../client/pages/c-log/image-clogs'
import VideoClogs from '../client/pages/c-log/video-clogs'
import TagClogs from '../client/pages/c-log/tag-clogs'
import { renderRoutes } from 'react-router-config'

const Root = ({ route }) => (
    <div>
      {/* child routes won't render without this */}
      {renderRoutes(route.routes)}
    </div>
)

export default [
    // {
    //     component: Root,
    //     routes: [
            {
                path: "/v-shop/",
                exact: true,
                component: CLog,
                page: 'V-Shop',
                cn_page: '社区页'
            },
            {
                path: "/v-shop/im/:id",
                component: ImageClogs,
                page: 'V-Shop Image Details',
                cn_page: '社区详情页'
            },
            {
                path: "/v-shop/vi/:id",
                component: VideoClogs,
                page: 'V-Shop Details',
                cn_page: '社区详情页'
            },
            {
                path: "/v-shop/tag",
                component: TagClogs,
                page: 'V-Shop Tag Clogs',
                cn_page: 'HashTag列表页'
            }
    //     ]
    // }
]